import Axios from "../utils/axiosInstance";

// API for getting ticket count dashboard numbers
export const getTicketsCount = (headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tickets/ticketsCount`, {
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting issues list
export const getIssuesList = (headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tickets/getIssuesList`, {
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting tickets list by filter parameters
export const getTickets = (params = {}, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tickets/getTickets`, {
    params,
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for creating a new ticket
export const createTicket = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/tickets/createTicket`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for creating custom/other issue
export const createOtherIssue = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/tickets/createOtherIssue`, payload, {
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for searching tickets by query
export const searchTicketsByQuery = (query, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/tickets/searchBy`, {
    params: { query },
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for updating ticket details
export const updateTicket = (ticketNumber, payload, params = {}, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`/tickets/updateTicket/${ticketNumber}`, payload, {
    params,
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};
